// Shared lens state API — §46.3 decision 1: the lens gets its OWN per-user
// doc (routes/v2/lens.py) instead of riding a page's state doc; page docs
// keep page-specific fields only. Same request/response envelope as
// gs-graph/state ({state: {...}}) so the client patterns stay identical.
import { AxiosClient } from "./AxiosClient";

export const getLensState = () => AxiosClient.get("v2/lens/state");

export const putLensState = (state) =>
  AxiosClient.put("v2/lens/state", { state });

// §46.1 P4 page memories: ONE slot per (lens, page). `presetId` addresses the
// lens — a preset id, a dynamic lens id ("trending"), or null for the draft —
// and the server routes it to the right home. Never batched: a page writes its
// own slot only, so two scenes can never overwrite each other's memory.
export const getPageState = (page, presetId) =>
  AxiosClient.get("v2/lens/page-state", {
    params: { page, ...(presetId ? { presetId } : {}) },
  });

export const putPageState = (page, presetId, dims) =>
  AxiosClient.put("v2/lens/page-state", {
    page,
    presetId: presetId || null,
    dims,
  });
